import saas from '@/utils/saas'
import request from '@/utils/request'

function url(code) {
  const service = saas.ServiceName.FILE_API
  const api = 'FILE_VIEW'
  return saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api + '?code=' + code
}

function upload(form) {
  const service = saas.ServiceName.FILE_API
  const api = 'FILE_UPLOAD'
  const data = form
  return request({
    url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.headerUpload(),
    data
  })
}

function download(param) {
  const service = saas.ServiceName.FILE_API
  const api = 'FILE_DOWNLOAD'
  const data = saas.data(service, api, param)
  return request({
    url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data,
    responseType: 'blob'
  })
}

/**
 * 下载 response blob
 * @param response
 */
function output(response) {
  const disposition = response.headers['content-disposition']
  const dis = disposition.split(';')
  let filename = ''
  for (let d of dis) {
    d = d.trim()
    if (d.startsWith('filename=')) {
      filename = d
    }
  }
  const fn = filename.split('=')
  let name = fn[1]
  if (name.startsWith('\"') && name.endsWith('\"')) {
    name = name.substring(1, name.length - 1)
  }
  name = decodeURI(name)
  const blob = new Blob([response.data])
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.download = name
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()
}

const File = {
  url,
  upload,
  download,
  output
}

export default File
